import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { EventModel } from '../models/event.model';

export class Converters {
  static fromNgbDateStructToDate(date: NgbDateStruct): Date {
    return new Date(date.year, date.month - 1, date.day);
  }

  static fromNgbDateStructToDateWithTimes(date: NgbDateStruct, time: string): Date {
    return new Date(date.year, date.month - 1, date.day, Number(time.split(':')[0]), Number(time.split(':')[1]));
  }

  static fromDateToNgbDateStruct(date: Date): NgbDateStruct {
    if (typeof date === 'string') {
      date = new Date(Date.parse(date));
    }
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate()
    };
  }

  static fromDateToString(date: Date): string {
    if (typeof date === 'string') {
      date = new Date(Date.parse(date));
    }
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  }

  static fromDateToTimeString(date: Date): string {
    if (typeof date === 'string') {
      date = new Date(Date.parse(date));
    }
    return `${date.getHours() < 10 ? "0" + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()}`;
  }

  static fromGoogleCalendarEventToLocalEvent(gevent: any): EventModel {
    let event = new EventModel();

    event.id = gevent.id;
    event.calendarId = gevent.organizer.email;
    event.creator = gevent.organizer.email;
    event.titolo = gevent.summary;
    event.luogo = gevent.location;
    event.dataInizio = Converters.fromDateToNgbDateStruct(new Date(gevent.start.dateTime.value));
    event.dataFine = Converters.fromDateToNgbDateStruct(new Date(gevent.end.dateTime.value));
    event.date = new Date(gevent.start.dateTime.value);
    event.oraInizio = Converters.fromDateToTimeString(new Date(gevent.start.dateTime.value));
    event.oraFine = Converters.fromDateToTimeString(new Date(gevent.end.dateTime.value));

    if (gevent.extendedProperties) {
      // TODO deve diventare un array serializzato e salvato su extendedprotperties
      event.originalCreator = gevent.extendedProperties.shared.originalCreator ?
        gevent.extendedProperties.shared.originalCreator : gevent.organizer.email;
      event.sig = gevent.extendedProperties.shared.sig;
      event.nome = gevent.extendedProperties.shared.nome;
      event.cognome = gevent.extendedProperties.shared.cognome;
      event.cellulare = gevent.extendedProperties.shared.cellulare;
      event.sig2 = gevent.extendedProperties.shared.sig2;
      event.nome2 = gevent.extendedProperties.shared.nome2;
      event.cognome2 = gevent.extendedProperties.shared.cognome2;
      event.cellulare2 = gevent.extendedProperties.shared.cellulare2;
      event.tipoEvento = Number(gevent.extendedProperties.shared.tipoEvento);
      event.eventoOggetto = gevent.extendedProperties.shared.eventoOggetto;
      event.rifImmobile = gevent.extendedProperties.shared.rifImmobile;
      event.note = gevent.extendedProperties.shared.note;
      event.confermato = Boolean(JSON.parse(gevent.extendedProperties.shared.confermato));
    }

    event.attendees = gevent.attendees;
    return event;
  }
}
